import React, { useState } from "react";
import { Typography, Modal } from "antd";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ChevronLeft, ChevronRight, Play, X } from "lucide-react";
import "./Gallery.css";

const { Title, Text } = Typography;

const Gallery = () => {
  const [visible, setVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showVideo, setShowVideo] = useState(false);
  const [currentVideo, setCurrentVideo] = useState("");

  // Gallery items - replace with your actual content
  const galleryItems = [
    // Images
    {
      type: "image",
      src: "/svgs/plot_details.jpg",
      thumbnail: "/svgs/plot_details.jpg",
      title: "Plot Details",
    },
    {
      type: "image",
      src: "/svgs/house_details.jpg",
      thumbnail: "/svgs/house_details.jpg",
      title: "House Design",
    },
    {
      type: "image",
      src: "/svgs/layout.jpg",
      thumbnail: "/svgs/layout.jpg",
      title: "Property Layout",
    },
    {
      type: "image",
      src: "/svgs/enquiry.jpg",
      thumbnail: "/svgs/enquiry.jpg",
      title: "Contact Details",
    },
    // Videos
    {
      type: "video",
      src: "https://akwed.s3.us-east-1.amazonaws.com/public/main_vid.mp4",
      //   thumbnail: "/svgs/banner1-u.jpg",
      title: "Property Overview",
    },
    {
      type: "video",
      src: "https://akwed.s3.us-east-1.amazonaws.com/public/main_vid.mp4",
      thumbnail: "/svgs/banner2-u.jpg",
      title: "Amenities Tour",
    },
    // Additional placeholder items to show grid layout
    {
      type: "image",
      src: "/svgs/plot_details.jpg",
      thumbnail: "/svgs/plot_details.jpg",
      title: "Surrounding Area",
    },
    {
      type: "image",
      src: "/svgs/house_details.jpg",
      thumbnail: "/svgs/house_details.jpg",
      title: "Interior Features",
    },
    {
      type: "image",
      src: "/svgs/layout.jpg",
      thumbnail: "/svgs/layout.jpg",
      title: "Master Plan",
    },
    {
      type: "video",
      src: "https://akwed.s3.us-east-1.amazonaws.com/public/main_vid.mp4",
      thumbnail: "/svgs/banner2-u.jpg",
      title: "Location Highlights",
    },
    {
      type: "image",
      src: "/svgs/plot_details.jpg",
      thumbnail: "/svgs/plot_details.jpg",
      title: "Green Spaces",
    },
    {
      type: "image",
      src: "/svgs/house_details.jpg",
      thumbnail: "/svgs/house_details.jpg",
      title: "Entrance",
    },
    {
      type: "image",
      src: "/svgs/layout.jpg",
      thumbnail: "/svgs/layout.jpg",
      title: "Master Plan",
    },
    {
      type: "image",
      src: "/svgs/enquiry.jpg",
      thumbnail: "/svgs/enquiry.jpg",
      title: "Contact Details",
    },
    {
      type: "image",
      src: "/svgs/plot_details.jpg",
      thumbnail: "/svgs/plot_details.jpg",
      title: "Plot Details",
    },
    {
      type: "video",
      src: "https://akwed.s3.us-east-1.amazonaws.com/public/main_vid.mp4",
      //   thumbnail: "/svgs/banner1-u.jpg",
      title: "Property Overview",
    },
  ];

  const openCarousel = (index) => {
    setCurrentIndex(index);
    if (galleryItems[index].type === "video") {
      setShowVideo(true);
      setCurrentVideo(galleryItems[index].src);
    } else {
      setShowVideo(false);
    }
    setVisible(true);
  };

  const handleClose = () => {
    setVisible(false);
    setShowVideo(false);
  };

  const handlePrev = () => {
    const newIndex =
      (currentIndex - 1 + galleryItems.length) % galleryItems.length;
    setCurrentIndex(newIndex);
    if (galleryItems[newIndex].type === "video") {
      setShowVideo(true);
      setCurrentVideo(galleryItems[newIndex].src);
    } else {
      setShowVideo(false);
    }
  };

  const handleNext = () => {
    const newIndex = (currentIndex + 1) % galleryItems.length;
    setCurrentIndex(newIndex);
    if (galleryItems[newIndex].type === "video") {
      setShowVideo(true);
      setCurrentVideo(galleryItems[newIndex].src);
    } else {
      setShowVideo(false);
    }
  };

  // Slider settings for carousel
  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    autoplay: false,
    prevArrow: <ChevronLeft className="carousel-arrow carousel-arrow-left" />,
    nextArrow: <ChevronRight className="carousel-arrow carousel-arrow-right" />,
    beforeChange: (current, next) => {
      setCurrentIndex(next);
      if (galleryItems[next].type === "video") {
        setShowVideo(true);
        setCurrentVideo(galleryItems[next].src);
      } else {
        setShowVideo(false);
      }
    },
  };

  return (
    <div className="gallery-main-container">
      <div className="gallery-container">
        <div className="gallery-header">
          <Title level={2}>Media Gallery</Title>
          <Text type="secondary">
            Browse through our collection of images and videos
          </Text>
        </div>

        <div className="photos-grid">
          {galleryItems.map((item, index) => (
            <div
              key={index}
              className="gallery-photo-item"
              onClick={() => openCarousel(index)}
            >
              <div className="photo-wrapper">
                <img src={item.thumbnail} alt={item.title} />
                {item.type === "video" && (
                  <div className="video-play-icon">
                    <Play size={30} />
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Carousel Modal */}
      <Modal
        open={visible}
        onCancel={handleClose}
        footer={null}
        width="85%"
        centered
        className="gallery-modal"
        closeIcon={<X className="close-icon" size={24} />}
      >
        <div className="carousel-container">
          {showVideo ? (
            <div className="video-container">
              <video
                src={currentVideo}
                controls
                autoPlay
                className="carousel-video"
              />
              <div className="carousel-caption">
                <h3>{galleryItems[currentIndex].title}</h3>
              </div>
            </div>
          ) : (
            <div className="image-container">
              <button
                onClick={handlePrev}
                className="nav-button nav-button-left"
              >
                <ChevronLeft size={30} />
              </button>

              <div className="carousel-image-wrapper">
                <img
                  src={galleryItems[currentIndex].src}
                  alt={galleryItems[currentIndex].title}
                  className="carousel-image"
                />
                <div className="carousel-caption">
                  <h3>{galleryItems[currentIndex].title}</h3>
                </div>
              </div>

              <button
                onClick={handleNext}
                className="nav-button nav-button-right"
              >
                <ChevronRight size={30} />
              </button>
            </div>
          )}
        </div>
      </Modal>
    </div>
  );
};

export default Gallery;
